import React from 'react'
import clsx from 'clsx'
import { ReactComponent as GlobeIcon } from './globe.svg'
import { ReactComponent as MarkerIcon } from './marker.svg'
import style from './style.module.scss'

type locationDateProps = {
    classNames?: string[]
    location?: string
    place?: string
    date?: string
}

export const LocationDate: React.FC<locationDateProps> = ({
    classNames = [],
    location,
    place,
    date,
}) => {
    if (!date) {
        return null
    }

    return (
        <div className={clsx(style.locationDate, ...classNames)}>
            <div className={style.date}>{date}</div>

            {(location === 'online' || place) && (
                <div className={style.place}>
                    {location === 'online' ? (
                        <>
                            <GlobeIcon className={style.icon} />
                            <span>En ligne</span>
                        </>
                    ) : (
                        place && (
                            <>
                                <MarkerIcon className={style.icon} />
                                <span>{place}</span>
                            </>
                        )
                    )}
                </div>
            )}
        </div>
    )
}
